
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { generateCodeVerifier, generateCodeChallenge, randomString, buildQuery } from 'src/app/util/entra-id/pkce.util';
import { LoggerService } from 'src/app/services/logger.service';

@Injectable({ providedIn: 'root' })
export class EntraIdAuthService {
  private readonly STORAGE_KEYS = {
    codeVerifier: 'entra_code_verifier',
    state: 'entra_state',
    nonce: 'entra_nonce'
  };

  constructor(private logger: LoggerService) {}

  
  async startLoginRedirect(): Promise<void> {

    const cfg = environment.entraId;
    const env = environment;

    this.logger.log('EntraIdAuthService: entraId config OK');
    
    try {
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);
      const state = randomString(32);
      const nonce = randomString(32);

      sessionStorage.setItem(this.STORAGE_KEYS.codeVerifier, codeVerifier);
      sessionStorage.setItem(this.STORAGE_KEYS.state, state);
      sessionStorage.setItem(this.STORAGE_KEYS.nonce, nonce);

      const authorizeEndpoint = cfg.authority + '/oauth2/v2.0/authorize';
      //parametros enviado a Entra ID
      const params = {
        client_id: cfg.clientId,
        response_type: 'code',
        redirect_uri: env.urlAmbiente+cfg.redirectUri,
        response_mode: 'query',
        scope: (cfg.scopes || ['openid', 'profile', 'email']).join(' '),
        code_challenge: codeChallenge,
        code_challenge_method: 'S256',
        state: state,
        nonce: nonce,
        prompt: 'login'

      };

      const url = authorizeEndpoint + '?' + buildQuery(params);
      this.logger.log('EntraIdAuthService: authorize URL ready');
      //se llama a Entra ID
      window.location.assign(url);
    } catch (err) {
      console.error('[EntraIdAuthService] startLoginRedirect error:', err);
      this.logger.log('EntraIdAuthService: startLoginRedirect failed', err);
      throw err; // para que el componente muestre la alerta
    }
  }

  getStoredPkce(): { codeVerifier?: string; state?: string; nonce?: string } {
    const codeVerifier = sessionStorage.getItem(this.STORAGE_KEYS.codeVerifier);
    const state = sessionStorage.getItem(this.STORAGE_KEYS.state);
    const nonce = sessionStorage.getItem(this.STORAGE_KEYS.nonce);

    this.logger.log('EntraIdAuthService: PKCE read from storage');

    return {
      codeVerifier: codeVerifier || undefined,
      state: state || undefined,
      nonce: nonce || undefined
    };
  }

  clearPkce(): void {
    this.logger.log('EntraIdAuthService: clearPkce');

    sessionStorage.removeItem(this.STORAGE_KEYS.codeVerifier);
    sessionStorage.removeItem(this.STORAGE_KEYS.state);
    sessionStorage.removeItem(this.STORAGE_KEYS.nonce);
  }


  
 
  validatePreconditions(): void {
    const cfg = environment.entraId;

    if (!cfg || !cfg.clientId || !cfg.authority || !cfg.redirectUri) {
      this.logger.log('EntraIdAuthService: invalid config');
      throw new Error('Entra ID no está configurado');
    }

    const isSecure = (typeof window !== 'undefined' && (window as any).isSecureContext) || false;
    const hasSubtle = typeof crypto !== 'undefined' && !!(crypto as any).subtle && typeof (crypto as any).subtle.digest === 'function';

    if (!isSecure || !hasSubtle) {
      throw new Error('Navegador inválido para el ingreso por Login Federado.');
    }

    const hasTextEncoder = (typeof (window as any).TextEncoder !== 'undefined');
    this.logger.log('EntraIdAuthService: browser crypto support', { isSecure, hasSubtle, hasTextEncoder });

  }



}
